import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { ClaimController } from '../../controllers/ClaimController'
import { ClaimModel } from '../../models/ClaimModel'
import { GrantHistory } from '../../models/GrantHistory'
import { Option } from '../../models/Option'
import { ISupportSpinner } from '../../shared/Ajax'
import { Backdrop } from '../../shared/Backdrop'
import { Dialog } from '../../shared/Dialog'
import {
  AbnField, AcnField, AddressField, AnzicField, BooleanRadioButtonField, Checkbox, DateField, EmailField, FormItem, MoneyField, MultiLineField, NumberField, NumericRadioButtonField, NumericSelectField, PhoneField, TextField, validateFields, yesNoDataSource, yesNoPreferNotSayDataSource,
} from '../../shared/fields'
import { MaskedField } from '../../shared/fields/MaskedField'
import { SalutationField } from '../../shared/fields/SalutationField'
import { ShowIf } from '../../shared/fields/ShowIf'
import { TableBody, TableColumn } from '../../shared/table'
import { BusinessCategories, getFY } from '../../shared/Utility'
import { NextBackButtons } from './controls/NextBackButtons'

export interface BusinessPageProps {
    history: H.History
    model: ClaimModel
    onChange: { (changes: Partial<ClaimModel>): any }
    preview?: boolean
    addressCountries: Option<string>[]
}

export interface BusinessPageState {
    loading: boolean
    abnInvalid: boolean
    grantHistory: GrantHistory[]
    showGrantHistoryDialog: boolean
}

export class BusinessPage extends React.Component<BusinessPageProps, BusinessPageState> implements ISupportSpinner {
  // #region Fields

    abn: TextField
    trusteeAcn: TextField
    registeredName: TextField
    tradingName: TextField
    tradingNameChanged: BooleanRadioButtonField
    tradingNameChangedOn: DateField
    tradingNameChangedFrom: TextField
    businessCategory: NumericSelectField
    trusteeName: TextField
    businessCommencedOn: DateField
    indigenousOwned: NumericRadioButtonField
    physicalAddress: AddressField
    postalAddressDifferent: BooleanRadioButtonField
    postalAddress: AddressField
    convictions: BooleanRadioButtonField
    reviewOrPenality: BooleanRadioButtonField
    disqualificationDetails: MultiLineField
    insolvency: BooleanRadioButtonField
    anzic: AnzicField
    coreBusinessDescription: MultiLineField
    promotingGoods: Checkbox
    promotingServices: Checkbox
    promotingIP: Checkbox
    promotingKnowHow: Checkbox
    promotingEvents: Checkbox
    goodsManufacturedInAustralia: BooleanRadioButtonField
    s24SignificantChanges: BooleanRadioButtonField
    exportPrincipal: BooleanRadioButtonField
    contactTitle: SalutationField
    contactFirstName: TextField
    contactLastName: TextField
    contactPosition: TextField
    contactPhone: PhoneField
    contactMobile: PhoneField
    contactEmail: EmailField
    website: TextField
    accountBsb: MaskedField
    accountInstitution: TextField
    accountNumber: TextField
    accountName: TextField
    bankDetailsConfirmed: Checkbox
    totalIncome: MoneyField
    totalEmployeeNumber: NumberField
    alreadySubmittedError: HTMLDivElement
    invalidBusinessCategoryError: HTMLDivElement
    specialApprovalExpiryDate: TextField
    invalidBusinessCategoryGovernmentEntityWarning: HTMLDivElement

    // #endregion Fields

    ajax: ClaimController

    constructor(props: BusinessPageProps) {
      super(props)

      this.ajax = new ClaimController()

      this.state = {
        loading: false,
        abnInvalid: this.props.model.abnInvalid === true,
        grantHistory: [],
        showGrantHistoryDialog: false,
      }
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    componentDidUpdate(prevProps: BusinessPageProps, prevState: BusinessPageState) {
      if (this.props.model.abn != prevProps.model.abn) {
        this.ajax.prepopulate(this, this.props.model, (d) => {
          if (d) {
            this.setState({
              abnInvalid: false,
            }, () => {
              this.props.onChange(d)
            })
          } else {
            this.setState({
              abnInvalid: true,
            }, () => {
              this.props.onChange({
                registeredName: '',
                entityType: null,
                tradingName: '',
                acn: '',
                businessCommencedOn: null,
              })
            })
          }
        })
      }

      if (this.props.model.accountBsb !== prevProps.model.accountBsb
            && this.props.model.accountBsb
            && (this.props.model.accountBsb.match(/\d/g) || '').length === 6) {
        this.ajax.bsbSearch(this,
          this.props.model.accountBsb,
          (bsb) => {
            if (bsb) {
              this.props.onChange({
                accountInstitution: `${bsb.institutionCode}-${bsb.institutionName}`,
                bsbInvalid: false,
              })
            } else {
              this.props.onChange({
                accountInstitution: '',
                bsbInvalid: true,
              })
            }
          })
      }

      // #region Clear dependancies

      // If "trading name changed" changed to No, clear "date of name change" and "previouse name"
      if (this.props.model.tradingNameChanged != prevProps.model.tradingNameChanged
            && !this.props.model.tradingNameChanged
            && (this.props.model.tradingNameChangedFrom || this.props.model.tradingNameChangedOn)) {
        this.props.onChange({
          tradingNameChangedFrom: null,
          tradingNameChangedOn: null,
        })
      }

      // If "Is postal address is different" changed to No, clear "postal address"
      if (this.props.model.postalAddressDifferent != prevProps.model.postalAddressDifferent
            && !this.props.model.postalAddressDifferent
            && this.props.model.postalAddress) {
        this.props.onChange({
          postalAddress: null,
        })
      }

      // If "reviewOrPenality" or "convictions" changed to No, clear "postal address"
      if (((this.props.model.convictions != prevProps.model.convictions && !this.props.model.convictions)
            || (this.props.model.reviewOrPenality != prevProps.model.reviewOrPenality && !this.props.model.reviewOrPenality))
            && this.props.model.disqualificationDetails) {
        this.props.onChange({
          disqualificationDetails: null,
        })
      }

      // If "promotingGoods" changed to No, clear "goodsManufacturedInAustralia" and "s24SignificantChanges"
      if (this.props.model.promotingGoods != prevProps.model.promotingGoods
            && !this.props.model.promotingGoods
            && this.props.model.goodsManufacturedInAustralia) {
        this.props.onChange({
          goodsManufacturedInAustralia: null,
          s24SignificantChanges: null,
        })
      }

      // If "goodsManufacturedOverseas" changed to No, clear "s24SignificantChanges"
      if (this.props.model.goodsManufacturedInAustralia != prevProps.model.goodsManufacturedInAustralia
            && this.props.model.goodsManufacturedInAustralia
            && this.props.model.s24SignificantChanges) {
        this.props.onChange({
          s24SignificantChanges: null,
        })
      }

      // If "exportPrincipal" changed to No, clear "principalAdditionalDocument"
      if (this.props.model.exportPrincipal != prevProps.model.exportPrincipal
            && !this.props.model.exportPrincipal
            && this.props.model.principalAdditionalDocument) {
        this.props.onChange({
          principalAdditionalDocument: null,
        })
      }

      // If "businessCategory" changed...
      if (this.props.model.businessCategory != prevProps.model.businessCategory) {
        // If not Trust, clear "trustee name" and "trustee acn"
        if (this.props.model.businessCategory != BusinessCategories.Trust
                && (this.props.model.trusteeName || this.props.model.trusteeAcn)) {
          this.props.onChange({
            trusteeName: null,
            trusteeAcn: null,
          })
        }

        // If not company, clear claim related companies
        if (this.props.model.businessCategory != BusinessCategories.Company && this.props.model.claimRelatedCompanies) {
          this.props.onChange({
            claimRelatedCompanies: null,
          })
        }

        // If ApprovedBody, clear "performance measure"
        if (this.props.model.businessCategory == BusinessCategories.ApprovedBody && this.props.model.performanceMeasure) {
          this.props.onChange({
            performanceMeasure: null,
          })
        }
      }

      // #endregion Clear dependancies
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    next = () => {
      if (this.state.loading) {
        return
      }

      if (this.props.model.claimAlreadySubmitted) {
        this.alreadySubmittedError.focus()
        return
      }

      validateFields((res) => {
        if (!this.isValidBusinessCategory()) {
          this.invalidBusinessCategoryError.focus()
          return
        }

        if (res) {
          this.ajax.updateClaim(this, this.props.model, () => {
            this.props.history.push(`/claim/${this.props.model.claimId}/personalise`)
          })
        }
      },
      this.abn,
      this.trusteeAcn,
      this.registeredName,
      this.tradingName,
      this.tradingNameChanged,
      this.tradingNameChangedOn,
      this.tradingNameChangedFrom,
      this.businessCategory,
      this.trusteeName,
      this.businessCommencedOn,
      this.indigenousOwned,
      this.physicalAddress,
      this.postalAddressDifferent,
      this.postalAddress,
      this.convictions,
      this.reviewOrPenality,
      this.disqualificationDetails,
      this.insolvency,
      this.anzic,
      this.coreBusinessDescription,
      this.promotingGoods,
      this.promotingServices,
      this.promotingIP,
      this.promotingKnowHow,
      this.promotingEvents,
      this.goodsManufacturedInAustralia,
      this.s24SignificantChanges,
      this.exportPrincipal,
      this.contactTitle,
      this.contactFirstName,
      this.contactLastName,
      this.contactPosition,
      this.contactPhone,
      this.contactMobile,
      this.contactEmail,
      this.website,
      this.accountBsb,
      this.accountInstitution,
      this.accountNumber,
      this.accountName,
      this.bankDetailsConfirmed,
      this.totalIncome,
      this.totalEmployeeNumber)
    }

    isValidBusinessCategory(): boolean {
      const entityTypesCategoryMapping = [
        { category: BusinessCategories.Individual, entityTypes: ['Individual/Sole Trader'] },
        { category: BusinessCategories.Company, entityTypes: ['Australian Private Company', 'Australian Public Company'] },
        { category: BusinessCategories.CoOperative, entityTypes: ['Co-operative'] },
        { category: BusinessCategories.Partnership, entityTypes: ['Family Partnership', 'Limited Partnership', 'Other Partnership'] },
        { category: BusinessCategories.BodyCorp, entityTypes: ['Other Incorporated entity', 'Other Unincorporated Entity'] }, // 'Other Incorporated entity' mapped to Body Corporate - as discussed with John. 'Other Unincorporated Entity' mapped to BodyCorp as discussed with Jen, DevOps #21219
        {
          category: BusinessCategories.ApprovedBody,
          entityTypes: ['Australian Private Company',
            'Australian Public Company',
            'Commonwealth Government Entity',
            'Commonwealth Government Other Incorporated Entity',
            'Co-operative',
            'Local Government Entity',
            'Local Government Other Incorporated Entity',
            'Other Incorporated entity',
            'State Government Entity',
            'State Government Other Incorporated Entity',
            'Territory Government Entity',
            'Territory Government Other Incorporated Entity',
            'Commonwealth Government Statutory Authority',
            'State Government Statutory Authority',

          ],
        },
        {
          category: BusinessCategories.GovernmentEntity,
          entityTypes: ['Commonwealth Government Company',
            'Commonwealth Government Co-operative',
            'Commonwealth Government Entity',
            'Commonwealth Government Other Incorporated Entity',
            'Commonwealth Government Partnership',
            'Commonwealth Government Private Company',
            'Commonwealth Government Public Company',
            'Local Government Company',
            'Local Government Co-operative',
            'Local Government Entity',
            'Local Government Other Incorporated Entity',
            'Local Government Private Company',
            'Local Government Public Company',
            'State Government Company',
            'State Government Entity',
            'State Government Other Incorporated Entity',
            'State Government Private Company',
            'State Government Public Company',
            'Territory Government Entity',
            'Territory Government Other Incorporated Entity',
          ],
        },
        {
          category: BusinessCategories.Trust,
          entityTypes: ['Corporate Unit Trust',
            'Deceased Estate',
            'Discretionary Investment Trust',
            'Discretionary Services Management Trust',
            'Discretionary Trading Trust',
            'Fixed Trust',
            'Fixed Unit Trust',
            'Hybrid Trust',
            'Listed Public Unit Trust',
            'Other Trust',
            'Public Trading Trust',
            'Unlisted Public Unit Trust',
          ],
        },
      ]

      if (this.props.model.businessCategory && this.props.model.entityType && this.props.model.entityType.label) {
        const validEntityTypes = entityTypesCategoryMapping.filter((m) => m.category == this.props.model.businessCategory)
        if (validEntityTypes.length > 0) {
          const entityType = this.props.model.entityType.label.toUpperCase()
          for (const e of validEntityTypes[0].entityTypes) {
            if (e.toUpperCase() == entityType) {
              return true
            }
          }
          return false
        }
      }
      return true
    }

    showGrantHistory = () => {
      this.ajax.getGrantHistory(this, this.props.model.abn, (d) => {
        this.setState({
          grantHistory: d.sort((a, b) => (a.year > b.year ? -1 : 1)),
          showGrantHistoryDialog: true,
        })
      })
    }

    closeGrantHistory = () => {
      this.setState({ showGrantHistoryDialog: false })
    }

    showExpiryDate = () => this.props.model.businessCategory === BusinessCategories.ApprovedBody
            || this.props.model.businessCategory === BusinessCategories.ApprovedJointVenture

    render() {
      const businessCategories = [
        { value: BusinessCategories.Individual, label: 'An individual who is a resident of Australia' },
        { value: BusinessCategories.Company, label: 'A company incorporated under the Corporations Act 2001' },
        { value: BusinessCategories.CoOperative, label: 'An association or co-operative incorporated under an Australian law' },
        { value: BusinessCategories.Partnership, label: 'A partnership regulated by an Australian law' },
        { value: BusinessCategories.BodyCorp, label: 'A body corporate established for a public purpose by or under an Australian law' },
        { value: BusinessCategories.ApprovedJointVenture, label: 'Approved Joint Venture' },
        { value: BusinessCategories.ApprovedBody, label: 'Approved Body' },
        { value: BusinessCategories.GovernmentEntity, label: 'Government Entity' },
        { value: BusinessCategories.Trust, label: 'Trust' },
      ]

      const grantGistoryColumns: TableColumn<GrantHistory>[] = [
        { name: 'Year', content: (r) => r.year },
        { name: 'Amount', content: (r) => r.amount },
      ]

      return (
        <>
          <h2>Business Details</h2>
          <AbnField
            ref={(r) => this.abn = r}
            id="abn"
            label="1. Australian Business Number (ABN)"
            value={this.props.model.abn}
            onChange={(abn) => this.props.onChange({ abn })}
            required
            block={false}
            disabled={!this.props.model.isConsultant}
            errorMessage={this.state.abnInvalid ? 'ABN not found' : null}
            preview={this.props.preview}
          />

          <div className="mt-3" style={{ display: this.props.model.grantsReceivedCountAsPerCMS ? '' : 'none' }}>
            <Alert className='emdg-page-alerts'>
              <p className="mb-2">{`Grants received or to be assessed: ${this.props.model.grantsReceivedCountAsPerCMS} grants.`}</p>
              <Button
           className='emdg-btn emdg-btn--secondary'
                id="btnGrantHistory"
                onClick={this.showGrantHistory}
              >
                View details
              </Button>
            </Alert>
          </div>

          <TextField
            ref={(r) => this.registeredName = r}
            id="registeredName"
            label="2. Registered business name as per ABR record"
            value={this.props.model.registeredNameLocal || this.props.model.registeredName}
            onChange={(registeredName) => this.props.onChange({ registeredName })}
            required
            disabled
            preview={this.props.preview}
          />

          <div tabIndex={-1} ref={(r) => this.alreadySubmittedError = r} className="mt-3" style={{ display: this.props.model.claimAlreadySubmitted ? '' : 'none' }}>
            <Alert className='emdg-page-alerts emdg-page-alerts--error'>
              An application has already been submitted for the specified ABN for this grant year. Application cannot be submitted.
            </Alert>
          </div>

          <TextField
            ref={(r) => this.tradingName = r}
            id="tradingName"
            label="3. Business or trading name (if different to the Registered business name)"
            value={this.props.model.tradingName}
            maxLength={80}
            onChange={(tradingName) => this.props.onChange({ tradingName })}
            preview={this.props.preview}
          />
          <BooleanRadioButtonField
            ref={(r) => this.tradingNameChanged = r}
            id="tradingNameChanged"
            label={(
              <span>
                {`4. ${this.props.model.grantsReceived ? 'Since your last EMDG application, did ' : 'Did '}the business have a registered or trading name not listed in the ABR or `}
                <a href={`https://abr.business.gov.au/AbnHistory/View?id=${this.props.model.abn}`} target="_blank" rel="noreferrer">business name history</a>
                ?
              </span>
)}
            value={this.props.model.tradingNameChanged}
            onChange={(tradingNameChanged) => this.props.onChange({ tradingNameChanged })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
          />
          <ShowIf condition={this.props.model.tradingNameChanged}>
            <DateField
              ref={(r) => this.tradingNameChangedOn = r}
              id="tradingNameChangedOn"
              label="5. Date of name change (dd/mm/yyyy)?"
              value={this.props.model.tradingNameChangedOn}
              onChange={(tradingNameChangedOn) => this.props.onChange({ tradingNameChangedOn })}
              required={this.props.model.tradingNameChanged}
              preview={this.props.preview}
            />
            <TextField
              ref={(r) => this.tradingNameChangedFrom = r}
              id="tradingNameChangedFrom"
              label="6. Previous business name"
              value={this.props.model.tradingNameChangedFrom}
              maxLength={255}
              onChange={(tradingNameChangedFrom) => this.props.onChange({ tradingNameChangedFrom })}
              required={this.props.model.tradingNameChanged}
              preview={this.props.preview}
            />
          </ShowIf>
          <NumericSelectField
            ref={(r) => this.businessCategory = r}
            id="businessCategory"
            label="7. Which one of the following categories applies to your business?"
            value={this.props.model.businessCategory}
            onChange={(businessCategory) => this.props.onChange({ businessCategory })}
            dataSource={businessCategories}
            required
            preview={this.props.preview}
          />
          <div tabIndex={-1} ref={(r) => this.invalidBusinessCategoryGovernmentEntityWarning = r} className="mt-2" style={{ display: this.props.model.businessCategory !== BusinessCategories.GovernmentEntity ? 'none' : '' }}>
            <Alert className='emdg-page-alerts emdg-page-alerts--warning '>
              <p>Most government entities are not eligible for EMDG. We recommend that you check with us before proceeding with the application.</p>
            </Alert>
          </div>
          <div tabIndex={-1} ref={(r) => this.invalidBusinessCategoryError = r} className="mt-2" style={{ display: this.isValidBusinessCategory() ? 'none' : '' }}>
            <Alert className='emdg-page-alerts emdg-page-alerts--error'>
              <p>The business category that you have selected does not match the details in the Australian Business Register. Please check that you are logging in with the correct ABN or have selected the correct entity type.</p>
            </Alert>
          </div>

          <TextField
            ref={(r) => this.specialApprovalExpiryDate = r}
            id="specialApprovalExpiryDate"
            label="Your Approved Status expiry date is (dd/mm/yyyy)"
            value={this.props.model.specialApprovalExpiryDate || 'N/A'}
            onChange={(specialApprovalExpiryDate) => this.props.onChange({ specialApprovalExpiryDate })}
            disabled
            visible={this.showExpiryDate()}
            preview={this.props.preview && this.showExpiryDate()}
            block={false}
          />
          <div className="mt-2" style={{ display: this.showExpiryDate() ? '' : 'none' }}>
            <Alert className='emdg-page-alerts emdg-page-alerts--warning '>
              If you have not submitted your
              {' '}
              {this.props.model.businessCategory === BusinessCategories.ApprovedBody
                ? <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-Approved-Body-Requirements.pdf.aspx" target="_blank" rel="noreferrer">application</a>
                : <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-Approved-Joint-Venture.pdf.aspx" target="_blank" rel="noreferrer">application</a>}
              {' '}
              for Approved Status you may upload your application now or provide it separately.
            </Alert>
          </div>

          <TextField
            ref={(r) => this.trusteeName = r}
            id="trusteeName"
            label="8. Provide the name of the trustee"
            value={this.props.model.trusteeName}
            onChange={(trusteeName) => this.props.onChange({ trusteeName })}
            maxLength={80}
            required={this.props.model.businessCategory == BusinessCategories.Trust}
            visible={this.props.model.businessCategory == BusinessCategories.Trust}
            preview={this.props.preview}
          />
          <AcnField
            ref={(r) => this.trusteeAcn = r}
            id="trusteeAcn"
            label="9. Provide the trustee's Australian Company Number (ACN) if applicable?"
            value={this.props.model.trusteeAcn}
            onChange={(trusteeAcn) => this.props.onChange({ trusteeAcn })}
            block={false}
            visible={this.props.model.businessCategory == BusinessCategories.Trust}
            preview={this.props.preview}
          />
          <DateField
            ref={(r) => this.businessCommencedOn = r}
            id="businessCommenceDate"
            label="10. What date did your business operations commence (dd/mm/yyyy)?"
            value={this.props.model.businessCommencedOn}
            onChange={(businessCommencedOn) => this.props.onChange({ businessCommencedOn })}
            required
            preview={this.props.preview}
          />
          <NumericRadioButtonField
            ref={(r) => this.indigenousOwned = r}
            id="indigenousOwned"
            label="11. Is this business Indigenous-owned (50% share or more)?"
            value={this.props.model.indigenousOwned}
            onChange={(indigenousOwned) => this.props.onChange({ indigenousOwned })}
            dataSource={yesNoPreferNotSayDataSource}
            required
            preview={this.props.preview}
          />
          <AddressField
            ref={(r) => this.physicalAddress = r}
            id="physicalAddress"
            label="12. Provide your business location (physical operating address)."
            value={this.props.model.physicalAddress}
            onChange={(physicalAddress) => this.props.onChange({ physicalAddress })}
            required
            preview={this.props.preview}
            australianAddressesOnly
            countries={this.props.addressCountries}
          />
          <BooleanRadioButtonField
            ref={(r) => this.postalAddressDifferent = r}
            id="postalAddressDifferent"
            label="13. Is your postal address different to the address above?"
            value={this.props.model.postalAddressDifferent}
            onChange={(postalAddressDifferent) => this.props.onChange({ postalAddressDifferent })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
          />
          <AddressField
            ref={(r) => this.postalAddress = r}
            id="postalAddress"
            label="14. Please provide your postal address."
            value={this.props.model.postalAddress}
            onChange={(postalAddress) => this.props.onChange({ postalAddress })}
            required={this.props.model.postalAddressDifferent}
            visible={this.props.model.postalAddressDifferent || false}
            preview={this.props.preview}
            australianAddressesOnly
            countries={this.props.addressCountries}
          />
          <BooleanRadioButtonField
            ref={(r) => this.convictions = r}
            id="convictions"
            label="15. In the past 5 years, have you or your associates been disqualified from running a corporation, been released from prison or been convicted of any offence?"
            value={this.props.model.convictions}
            onChange={(convictions) => this.props.onChange({ convictions })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
            help={(
              <>
                <h5>Disqualifying Convictions</h5>
                {' '}
                <p>You or your associate/s must be free of any disqualifying convictions both at the time of lodging your application and at the time of becoming entitled to and receiving your final payment.</p>
                <h5>Associates</h5>
                {' '}
                <p>As defined by section 107 of the Export Market Development Grant Act 1997 and section 2.2 of the Export Market Development Grants (Associate and Fit and Proper Person) Guidelines 2015.</p>
                <h5>Outstanding disqualifying convictions</h5>
                {' '}
                <p>Refer to sections 16 and 17 of the Export Market Development Grant Act 1997.</p>
              </>
)}
          />
          <BooleanRadioButtonField
            ref={(r) => this.reviewOrPenality = r}
            id="reviewOrPenality"
            label="16. In the past 5 years, have you or your associates been the subject of a formal review or proceeding or civil penalty or investigation by any regulatory agency, tribunal, official inquiry or court in Australia or overseas?"
            value={this.props.model.reviewOrPenality}
            onChange={(reviewOrPenality) => this.props.onChange({ reviewOrPenality })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
          />
          <MultiLineField
            ref={(r) => this.disqualificationDetails = r}
            id="disqualificationDetails"
            label="17. Please provide details of disqualification or formal review or proceeding or civil penalty or investigation"
            value={this.props.model.disqualificationDetails}
            onChange={(disqualificationDetails) => this.props.onChange({ disqualificationDetails })}
            required={(this.props.model.convictions || this.props.model.reviewOrPenality) || false}
            visible={(this.props.model.convictions || this.props.model.reviewOrPenality) || false}
            preview={this.props.preview}
            maxLength={512}
          />
          <BooleanRadioButtonField
            ref={(r) => this.insolvency = r}
            id="insolvency"
            label={(
              <span>
                18. Are you or your associate or, if the application is on behalf of a trust estate, a trust estate beneficiary or an associate of the beneficiary currently under
                <a href="https://www.austrade.gov.au/ArticleDocuments/6917/form-help.pdf.aspx" target="_blank" rel="noreferrer">insolvency administration</a>
                ?
              </span>
)}
            value={this.props.model.insolvency}
            onChange={(insolvency) => this.props.onChange({ insolvency })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
          />
          <div className="mt-2" style={{ display: this.props.model.insolvency ? '' : 'none' }}>
            <Alert className='emdg-page-alerts emdg-page-alerts--warning '>
              No grant is payable if an Applicant or any associate/s of the applicant is subject to insolvency administration at the time that Austrade determines that it is otherwise entitled to receive a grant.
            </Alert>
          </div>

          <h3>Products  & Services</h3>

          <AnzicField
            ref={(r) => this.anzic = r}
            id="anzic"
            label="19. Select your industry"
            value={this.props.model.anzic}
            onChange={(anzic) => this.props.onChange({ anzic })}
            required
            preview={this.props.preview}
          />
          <FormItem label={<span className="form-content-preview">20. What are you promoting. Select all that apply.</span>}>
            <Checkbox
              ref={(r) => this.promotingGoods = r}
              id="promotingGoods"
              label="Goods"
              value={this.props.model.promotingGoods}
              onChange={(promotingGoods) => this.props.onChange({ promotingGoods })}
              preview={this.props.preview}
              help={(
                <>
                  <h5>Export Goods</h5>
                  <p>
                    Goods
                    <a href="https://www.austrade.gov.au/ArticleDocuments/6917/form-help.pdf.aspx" target="_blank" rel="noreferrer">made in Australia</a>
                    {' '}
                    are Australian primary products, or are made primarily from Australian primary products or are manufactured or assembled in Australia. Where the goods are not made in Australia you are required to prepare a submission requesting consideration of eligibility.
                  </p>
                </>
)}
            />
            <Checkbox
              ref={(r) => this.promotingServices = r}
              id="promotingServices"
              label="Services"
              value={this.props.model.promotingServices}
              onChange={(promotingServices) => this.props.onChange({ promotingServices })}
              preview={this.props.preview}
            />
            <Checkbox
              ref={(r) => this.promotingIP = r}
              id="promotingIP"
              label="IP"
              value={this.props.model.promotingIP}
              onChange={(promotingIP) => this.props.onChange({ promotingIP })}
              preview={this.props.preview}
            />
            <Checkbox
              ref={(r) => this.promotingKnowHow = r}
              id="promotingKnowHow"
              label="Know How"
              value={this.props.model.promotingKnowHow}
              onChange={(promotingKnowHow) => this.props.onChange({ promotingKnowHow })}
              preview={this.props.preview}
            />
            <Checkbox
              ref={(r) => this.promotingEvents = r}
              id="promotingEvents"
              label="Events"
              value={this.props.model.promotingEvents}
              onChange={(promotingEvents) => this.props.onChange({ promotingEvents })}
              preview={this.props.preview}
            />
          </FormItem>

          <BooleanRadioButtonField
            ref={(r) => this.goodsManufacturedInAustralia = r}
            id="goodsManufacturedInAustralia"
            label="21. Are the goods made in Australia?"
            value={this.props.model.goodsManufacturedInAustralia}
            onChange={(goodsManufacturedInAustralia) => this.props.onChange({ goodsManufacturedInAustralia })}
            dataSource={yesNoDataSource}
            required={this.props.model.promotingGoods}
            visible={this.props.model.promotingGoods || false}
            preview={this.props.preview}
          />
          <div className="mt-2" style={{ display: this.props.model.promotingGoods ? '' : 'none' }}>
            <Alert className='emdg-page-alerts'>
              Goods
              {' '}
              <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-guide-to-exports.pdf.aspx" target="_blank" rel="noreferrer">made in Australia</a>
              {' '}
              are Australian primary products, or are made primarily from Australian primary products or are manufactured or assembled in Australia. Where the goods are not made in Australia you are required to prepare a submission requesting consideration of eligibility.
            </Alert>
          </div>
          <div className="mt-2" style={{ display: this.props.model.goodsManufacturedInAustralia === false ? '' : 'none' }}>
            <Alert className='emdg-page-alerts'>
              A s24b submission is required where the goods are not made in Australia. Attach
              {' '}
              {getFY(this.props.model.claimYear)}
              fy Profit & loss and Balance sheet as well as a document providing the information requested in the
              <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-24b-Goods-not-made-in-Australia-submission.docx.aspx" target="_blank" rel="noreferrer">S24b template.</a>
            </Alert>
          </div>
          <BooleanRadioButtonField
            ref={(r) => this.s24SignificantChanges = r}
            id="s24SignificantChanges"
            label="22. Has there been any significant change in circumstances to your last s24(b) submission (if you completed one)?"
            value={this.props.model.s24SignificantChanges}
            onChange={(s24SignificantChanges) => this.props.onChange({ s24SignificantChanges })}
            dataSource={yesNoDataSource}
            required={this.props.model.goodsManufacturedInAustralia === false}
            visible={this.props.model.goodsManufacturedInAustralia === false}
            preview={this.props.preview}
          />
          <MultiLineField
            ref={(r) => this.coreBusinessDescription = r}
            id="coreBusinessDescription"
            label="23. Provide a comprehensive description of the products and/or services you intend to sell to foreign residents."
            value={this.props.model.coreBusinessDescription}
            onChange={(coreBusinessDescription) => this.props.onChange({ coreBusinessDescription })}
            required
            preview={this.props.preview}
            maxLength={512}
          />
          <BooleanRadioButtonField
            ref={(r) => this.exportPrincipal = r}
            id="exportPrincipal"
            label={(
              <span>
                24. As the applicant, are you the
                <a href="https://www.austrade.gov.au/ArticleDocuments/6917/form-help.pdf.aspx" target="_blank" rel="noreferrer">principal</a>
                {' '}
                or intended principal in the export business you are promoting? Applicants are required to be the principal or intended principal to receive a grant unless they are Australian Manufacturers, Approved Bodies, Inbound Tour Operators and Event Promoters or they meet the requirements in s37 (1A) of the EMDG act.
              </span>
)}
            value={this.props.model.exportPrincipal}
            onChange={(exportPrincipal) => this.props.onChange({ exportPrincipal })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
            help={(
              <>
                <h5>Principal</h5>
                {' '}
                <p>In most cases you must own and be the seller of the goods or the provider of the services or intellectual property you intend to export to foreign residents.</p>
              </>
)}
          />

          <h3>Contact person - to discuss this application</h3>
          <p>25. Who in the Applicant business should we contact with enquiries?</p>
          <SalutationField
            ref={(r) => this.contactTitle = r}
            id="contactTitle"
            label="Title"
            value={this.props.model.contactTitle}
            onChange={(contactTitle) => this.props.onChange({ contactTitle })}
            required
            preview={this.props.preview}
          />
          <div className="clearfix">
            <TextField
              ref={(r) => this.contactFirstName = r}
              className="float-left mr-3"
              id="contactFirstName"
              label="First name"
              value={this.props.model.contactFirstName}
              onChange={(contactFirstName) => this.props.onChange({ contactFirstName })}
              required
              preview={this.props.preview}
              maxLength={50}
            />
            <TextField
              ref={(r) => this.contactLastName = r}
              className="float-left"
              id="contactLastName"
              label="Last name"
              value={this.props.model.contactLastName}
              onChange={(contactLastName) => this.props.onChange({ contactLastName })}
              required
              preview={this.props.preview}
              maxLength={50}
            />
          </div>
          <TextField
            ref={(r) => this.contactPosition = r}
            id="contactPosition"
            label="Job title or role"
            value={this.props.model.contactPosition}
            onChange={(contactPosition) => this.props.onChange({ contactPosition })}
            required
            preview={this.props.preview}
            maxLength={50}
          />
          <PhoneField
            ref={(r) => this.contactPhone = r}
            id="contactPhone"
            label="Telephone number (e.g. +61 2 9999 9999)"
            value={this.props.model.contactPhone}
            onChange={(contactPhone) => this.props.onChange({ contactPhone })}
            required
            block={false}
            preview={this.props.preview}
          />
          <PhoneField
            ref={(r) => this.contactMobile = r}
            id="contactMobile"
            label="Mobile phone number (e.g. +61 499 999 999)"
            value={this.props.model.contactMobile}
            onChange={(contactMobile) => this.props.onChange({ contactMobile })}
            block={false}
            preview={this.props.preview}
          />
          <EmailField
            ref={(r) => this.contactEmail = r}
            id="contactEmail"
            label="Business email"
            value={this.props.model.contactEmail}
            onChange={(contactEmail) => this.props.onChange({ contactEmail })}
            required
            preview={this.props.preview}
            maxLength={80}
          />
          <TextField
            ref={(r) => this.website = r}
            id="website"
            label="Business website address"
            value={this.props.model.website}
            onChange={(website) => this.props.onChange({ website })}
            required={false}
            preview={this.props.preview}
            maxLength={80}
          />

          <h3>Bank account details</h3>
          <p>26. What bank account should the grant payment be credited to?</p>
          <Alert className='emdg-page-alerts'>
            <b>Payment of your grant.</b>
            {' '}
            The information provided below by the applicant is an authority and direction to Austrade as to how the grant payment is to be made. The applicant acknowledges that a payment made in accordance with that direction will discharge Austrade's obligations in respect of payment to the applicant and releases Austrade from any liability arising therefrom. If the applicant wishes to change its direction to Austrade, it must do so in writing before the grant payment is made.
          </Alert>

          <MaskedField
            ref={(r) => this.accountBsb = r}
            id="accountBsb"
            label="BSB number"
            value={this.props.model.accountBsb}
            onChange={(accountBsb) => this.props.onChange({ accountBsb })}
            required
            block={false}
            preview={this.props.preview}
            mask="999-999"
            errorMessage={this.props.model.accountBsb && (this.props.model.accountBsb.match(/\d/g) || '').length != 6 && 'Bsb number must be 6 digits'}
          />
          {this.props.model.bsbInvalid && (
          <Alert className='emdg-page-alerts emdg-page-alerts--warning '>
            <b>The BSB you entered was not on our list. We will be in contact to confirm the details once the application is lodged.</b>
          </Alert>
          )}

          <TextField
            ref={(r) => this.accountInstitution = r}
            id="accountInstitution"
            label="Financial institution and branch"
            value={this.props.model.accountInstitution}
            onChange={(accountInstitution) => this.props.onChange({ accountInstitution })}
            required
            maxLength={80}
            preview={this.props.preview}
          />
          <TextField
            ref={(r) => this.accountNumber = r}
            id="accountNumber"
            label="Account number"
            value={this.props.model.accountNumber}
            onChange={(accountNumber) => this.props.onChange({ accountNumber })}
            required
            maxLength={30}
            preview={this.props.preview}
            errorMessage={this.props.model.accountNumber && (this.props.model.accountNumber.match(/\d/g) || '').length == 0 && 'Account number must contain digits'}
          />
          <TextField
            ref={(r) => this.accountName = r}
            id="accountName"
            label="Name of bank account"
            value={this.props.model.accountName}
            onChange={(accountName) => this.props.onChange({ accountName })}
            required
            maxLength={80}
            preview={this.props.preview}
          />
          <div className="form-item" style={{ display: this.props.model.bankDetailsPrepopulated ? '' : 'none' }}>
            <Checkbox
              ref={(r) => this.bankDetailsConfirmed = r}
              id="bankDetailsConfirmed"
              required={this.props.model.bankDetailsPrepopulated}
              requiredMessage="Please confirm the bank details are correct"
              onChange={(bankDetailsConfirmed) => this.props.onChange({ bankDetailsConfirmed })}
              value={this.props.model.bankDetailsConfirmed}
              label={<span>I confirm that the bank details are correct.</span>}
              preview={this.props.preview}
            />
          </div>

          <h3>Financial position</h3>
          <MoneyField
            ref={(r) => this.totalIncome = r}
            id="totalIncome"
            label={(
              <span>
                27. What was the total
                <a href="https://www.legislation.gov.au/Details/C2016C00793/Html/Text#_Toc456170219" target="_blank" rel="noreferrer">income</a>
                {' '}
                (i.e. your total turnover including sales) of your business for
                {getFY(this.props.model.claimYear)}
                ?
              </span>
)}
            value={this.props.model.totalIncome}
            onChange={(totalIncome) => this.props.onChange({ totalIncome })}
            required
            allowZero
            block={false}
            preview={this.props.preview}
            help={(
              <>
                <h5>Total Income</h5>
                <p>Your total turnover includes gross sales.</p>
              </>
)}
          />
          <div className="mt-2">
            <Alert className={this.props.model.businessCategory != 7 && this.props.model.totalIncome > 50000000 ? 'emdg-page-alerts emdg-page-alerts-warning' : 'emdg-page-alerts'}>
              If your assessable income in
              {' '}
              {getFY(this.props.model.claimYear)}
              {' '}
              exceeded A$50 million you are not eligible for a grant except if you are an Approved Body applicant.
            </Alert>
          </div>

          <NumberField
            ref={(r) => this.totalEmployeeNumber = r}
            id="totalEmployeeNumber"
            label={`28. What was the total number of employees of your business at 30 June ${this.props.model.claimYear} that reside in Australia (include all the full time and part time employees, contractors and working Directors).`}
            value={this.props.model.totalEmployeeNumber}
            onChange={(totalEmployeeNumber) => this.props.onChange({ totalEmployeeNumber })}
            required
            min={1}
            max={32765}
            wholeNumbersOnly
            block={false}
            preview={this.props.preview}
          />

          <NextBackButtons
            onBack={() => this.props.history.push(`/claim/${this.props.model.claimId}/terms`)}
            onNext={this.next}
            preview={this.props.preview}
          />

          <Dialog
            id="grantHistory"
            title="Grant History"
            open={this.state.showGrantHistoryDialog}
            onClose={this.closeGrantHistory}
          >
            <TableBody<GrantHistory>
              id="grantHistory"
              columns={grantGistoryColumns}
              value={this.state.grantHistory}
              noRowsMessage="No grant history found"
              alwaysShowAllRows
            />
          </Dialog>

          <Backdrop on={this.state.loading} />
        </>
      )
    }
}
